import { render, staticRenderFns } from "./MalattieInfettiveStruttureEditComponent.vue?vue&type=template&id=5825bf0a"
import script from "./MalattieInfettiveStruttureEditComponent.vue?vue&type=script&lang=js"
export * from "./MalattieInfettiveStruttureEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports